import React, { Component } from 'react';
import * as firebase from 'firebase';
import MetaTags from 'react-meta-tags';
import scrollToComponent from 'react-scroll-to-component';
import ReactDOM from 'react-dom';
import Login from '../View/Login';
import BG from '../images/table9IconBg.svg';
import '../css/table.css';
import {
  ShareButtons,
  generateShareIcon
} from 'react-share'
const {
  FacebookShareButton,
  GooglePlusShareButton
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const GooglePlusIcon = generateShareIcon('google');

class Table9 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      send: false,
      loading: false,
      ans1: false,
      ans2: false,
      ans3: false,
      ans4: false,
      ans5: false,
      ans6: false,
      ans7: false,
      ans8: false,
      ans9: false,
      ans10: false,
      ans11: false,
      ans12: false,
      name: '飲食行為自我診斷',
      totalTest:'',
      url: 'herbalcure.com.tw/Table9',
      thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable9.jpg?alt=media&token=865c43d8-7ae6-4cc3-af66-55acf81f8510',
      fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable9.jpg?alt=media&token=865c43d8-7ae6-4cc3-af66-55acf81f8510'
    }
    // this.mouseMove = this.mouseMove.bind(this)
    this.tableBox = this.tableBox.bind(this)
    this.handleChangeAns1 = this.handleChangeAns1.bind(this)
    this.handleChangeAns2 = this.handleChangeAns2.bind(this)
    this.handleChangeAns3 = this.handleChangeAns3.bind(this)
    this.handleChangeAns4 = this.handleChangeAns4.bind(this)
    this.handleChangeAns5 = this.handleChangeAns5.bind(this)
    this.handleChangeAns6 = this.handleChangeAns6.bind(this)
    this.handleChangeAns7 = this.handleChangeAns7.bind(this)
    this.handleChangeAns8 = this.handleChangeAns8.bind(this)
    this.handleChangeAns9 = this.handleChangeAns9.bind(this)
    this.handleChangeAns10 = this.handleChangeAns10.bind(this)
    this.handleChangeAns11 = this.handleChangeAns11.bind(this)
    this.handleChangeAns12 = this.handleChangeAns12.bind(this)
    this.goToTable2 = this.goToTable2.bind(this)
    this.goToTable3 = this.goToTable3.bind(this)
    this.goToTable4 = this.goToTable4.bind(this)
    this.goToTable5 = this.goToTable5.bind(this)
    this.goToTable6 = this.goToTable6.bind(this)
    this.tableSave = this.tableSave.bind(this)
  }
  componentDidMount() {
    window.scrollTo(0,0)
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        tableBox.classList.add('isShow')
        const totalTestTableRef = firebase.database().ref().child('total')
        totalTestTableRef.on('value', snap => {
          this.setState({
            totalTest: snap.val().totalTest
          })
        })
       console.log(this.state.totalTest)
      } else {
        tableBox.classList.remove('isShow')
      }
    })
  }
  tableBox() {
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        tableBox.classList.add('isShow')
        scrollToComponent(tableBox, {
        	offset: -50,
        	align: 'top',
        	duration: 700
        })
      } else {
        tableBox.classList.remove('isShow')
        this.setState({ send: true})
        setTimeout(() => this.setState({ loading: true }), 400);
      }
    })
  }
  goToTable2() {
    const table1 = ReactDOM.findDOMNode(this.refs.table1)
    const table2 = ReactDOM.findDOMNode(this.refs.table2)
    table1.classList.remove('isShow')
    table2.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar);
    sliderBar.classList.add('is14-28')
  }
  goToTable3() {
    const table2 = ReactDOM.findDOMNode(this.refs.table2)
    const table3 = ReactDOM.findDOMNode(this.refs.table3)
    table2.classList.remove('isShow')
    table3.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar);
    sliderBar.classList.add('is28-56')
  }
  goToTable4() {
    const table3 = ReactDOM.findDOMNode(this.refs.table3)
    const table4 = ReactDOM.findDOMNode(this.refs.table4)
    table3.classList.remove('isShow')
    table4.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar);
    sliderBar.classList.add('is42-84')
  }
  goToTable5() {
    const table4 = ReactDOM.findDOMNode(this.refs.table4)
    const table5 = ReactDOM.findDOMNode(this.refs.table5)
    table4.classList.remove('isShow')
    table5.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar);
    sliderBar.classList.add('is57-12')
  }
  goToTable6() {
    const table5 = ReactDOM.findDOMNode(this.refs.table5)
    const table6 = ReactDOM.findDOMNode(this.refs.table6)
    table5.classList.remove('isShow')
    table6.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar);
    sliderBar.classList.add('is71-4')
  }
  tableSave(event) {
    event.preventDefault()
    const totalTestTableRef = firebase.database().ref().child('total')
    totalTestTableRef.update({
      totalTest: (this.state.totalTest * 1) + 1
    })
    const userId = firebase.auth().currentUser.uid
    const rootRef = firebase.database().ref('users/').child(userId).child('Answers').push()
    const postId = rootRef.key
    const total = ((this.state.ans1 * 1) + (this.state.ans2 * 1) + (this.state.ans3 * 1) + (this.state.ans4 * 1) + (this.state.ans5 * 1) + (this.state.ans6 * 1) + (this.state.ans7 * 1) + (this.state.ans8 * 1) + (this.state.ans9 * 1) + (this.state.ans10 * 1) + (this.state.ans11 * 1) + (this.state.ans12 * 1))
    if (total < 30) {
      rootRef.update({
        Reviews: '慘了！慘了！您的飲食行為非常糟糕，建議下定決心來減重。',
        ans: total,
        name: '飲食行為自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table9',
        localUrl: '/Table9',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable9.jpg?alt=media&token=865c43d8-7ae6-4cc3-af66-55acf81f8510',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable9.jpg?alt=media&token=865c43d8-7ae6-4cc3-af66-55acf81f8510'
      })
    } else if (total < 40) {
      rootRef.update({
        Reviews: '雖然您比0-30分好一點，也別『龜笑鱉無尾』，請努力改變自己的飲食習慣。',
        ans: total,
        name: '飲食行為自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table9',
        localUrl: '/Table9',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable9.jpg?alt=media&token=865c43d8-7ae6-4cc3-af66-55acf81f8510',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable9.jpg?alt=media&token=865c43d8-7ae6-4cc3-af66-55acf81f8510'
      })
    } else if (total < 60) {
      rootRef.update({
        Reviews: '加油！加油！飲食習慣再繼續改善小缺失，就更棒了。',
        ans: total,
        name: '飲食行為自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table9',
        localUrl: '/Table9',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable9.jpg?alt=media&token=865c43d8-7ae6-4cc3-af66-55acf81f8510',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable9.jpg?alt=media&token=865c43d8-7ae6-4cc3-af66-55acf81f8510'
      })
    } else {
      rootRef.update({
        Reviews: '您真棒！請持之以恆，就可以輕鬆獲得健康唷！',
        ans: total,
        name: '飲食行為自我診斷',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/Table9',
        localUrl: '/Table9',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable9.jpg?alt=media&token=865c43d8-7ae6-4cc3-af66-55acf81f8510',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2Ftable9.jpg?alt=media&token=865c43d8-7ae6-4cc3-af66-55acf81f8510'
      })
    }
    window.location = ('/Answer/' + postId);
  }
  handleChangeAns1(event) {
    this.setState({ans1: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.add('is8-3')
    const toQ2 = ReactDOM.findDOMNode(this.refs.toQ2)
    scrollToComponent(toQ2, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns2(event) {
    this.setState({ans2: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is8-3')
    sliderBar.classList.add('is16-6')
    const toNext1 = ReactDOM.findDOMNode(this.refs.toNext1)
    scrollToComponent(toNext1, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns3(event) {
    this.setState({ans3: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is16-6')
    sliderBar.classList.add('is24-9')
    const toQ4 = ReactDOM.findDOMNode(this.refs.toQ4)
    scrollToComponent(toQ4, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns4(event) {
    this.setState({ans4: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is24-9')
    sliderBar.classList.add('is33-2')
    const toNext2 = ReactDOM.findDOMNode(this.refs.toNext2)
    scrollToComponent(toNext2, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns5(event) {
    this.setState({ans5: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is33-2')
    sliderBar.classList.add('is41-5')
    const toQ6 = ReactDOM.findDOMNode(this.refs.toQ6)
    scrollToComponent(toQ6, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns6(event) {
    this.setState({ans6: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is41-5')
    sliderBar.classList.add('is49-8')
    const toNext3 = ReactDOM.findDOMNode(this.refs.toNext3)
    scrollToComponent(toNext3, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns7(event) {
    this.setState({ans7: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is49-8')
    sliderBar.classList.add('is58-1')
    const toQ8 = ReactDOM.findDOMNode(this.refs.toQ8)
    scrollToComponent(toQ8, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns8(event) {
    this.setState({ans8: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is58-1')
    sliderBar.classList.add('is66-4')
    const toNext4 = ReactDOM.findDOMNode(this.refs.toNext4)
    scrollToComponent(toNext4, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns9(event) {
    this.setState({ans9: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is66-4')
    sliderBar.classList.add('is74-7')
    const toQ10 = ReactDOM.findDOMNode(this.refs.toQ10)
    scrollToComponent(toQ10, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns10(event) {
    this.setState({ans10: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is74-7')
    sliderBar.classList.add('is83')
    const toNext5 = ReactDOM.findDOMNode(this.refs.toNext5)
    scrollToComponent(toNext5, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns11(event) {
    this.setState({ans11: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is83')
    sliderBar.classList.add('is91-3')
    const toQ12 = ReactDOM.findDOMNode(this.refs.toQ12)
    scrollToComponent(toQ12, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns12(event) {
    this.setState({ans12: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is91-3')
    sliderBar.classList.add('is100')
    const toNext6 = ReactDOM.findDOMNode(this.refs.toNext6)
    scrollToComponent(toNext6, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  render(postId) {
    const { loading } = this.state;
    if(loading) {
      return <div style={{display: this.state.send ? 'flex' : 'none', background: '#eeede9',justifyContent: 'center', alignItems:'center'}} >
        <Login />
      </div>
    }
    const nextBtn1 = ((this.state.ans1 + this.state.ans2) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable2}>下一題</div>
     : null
    const nextBtn2 = ((this.state.ans3 + this.state.ans4) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable3}>下一題</div>
     : null
    const nextBtn3 = ((this.state.ans5 + this.state.ans6) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable4}>再接再厲</div>
     : null
    const nextBtn4 = ((this.state.ans7 + this.state.ans8) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable5}>下一題</div>
     : null
    const nextBtn5 = ((this.state.ans9 + this.state.ans10) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.goToTable6}>再接再厲</div>
     : null
    const nextBtn6 = ((this.state.ans11 + this.state.ans12) * 1)
     ? <div className="nextTablebtnDefault" onClick={this.tableSave}>完成!提交吧</div>
     : null

    return (
      <div>
        <MetaTags>
            <title>草學藥事 || {this.state.name}</title>
            <meta id="og-title" property="og:title" content={this.state.name} />
        </MetaTags>
        <div className="animationBox" style={Jeyu.Banner} ref="banner">
         <div className="container">
          <div className="row">
          <div style={Jeyu.Slogan} className="slogan table9">
           <h1>你的飲食習慣如何?</h1>
           <h2>吃對東西 才有健康</h2>
           <p className="moileNone">
           上班總是遲到，習慣早餐當成中餐吃<br />
           懶得自己開火，在外解決輕鬆又方便<br />
           享有健康身體，必須從改變飲食做起
           </p>
           <span className="tableBtnDefault" onClick={this.tableBox}>開始檢測</span>
           <article className="fbBox">
                  <div className="Demo__some-network">
                     <FacebookShareButton
                       url='https://herbalcure.com.tw/Table9'
                       quote={this.state.name}
                       className="Demo__some-network__share-button">
                       <FacebookIcon
                         size={26}
                         round />
                     </FacebookShareButton>
                   </div>
                   <div className="Demo__some-network">
                     <GooglePlusShareButton
                       url='https://herbalcure.com.tw/Table9'
                       className="Demo__some-network__share-button">
                       <GooglePlusIcon
                         size={26}
                         round />
                     </GooglePlusShareButton>
                   </div>
           </article>
          </div>
          </div>
         </div>
        </div>
        <div className="tableBox table2Height" ref="tableBox" style={Jeyu.tableBox}>
         <div className="container">
          <div className="row">
          <div className="tableFlexBox">
           <div className="mobilePd20">
            <h2>飲食行為自我診斷</h2>
            <sub>請您根據最近一週的飲食狀態，選擇適當答案。<br />
             <span>總是：十次中有八次以上是如此</span>
             <span>常常：十次中有六至八次</span>
             <span>偶爾：十次中有三至五次</span>
             <span>很少：十次中有一至二次或全非如此</span>
            </sub>
           </div>
            <div className="sliderBar" ref="sliderBar"></div>
            <section className="">
             <form className="tableForm">
             <div className="table1 isShow" ref="table1">
              <article ref="toQ2">
               <h1>Q1:我定時吃三餐。</h1>
               <input type="radio" value='1'
                id="ans1"
                checked={this.state.ans1 === '1'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans1">很少</label>
               <input type="radio" value='3'
                id="ans2"
                checked={this.state.ans1 === '3'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans2">偶爾</label>
               <input type="radio" value='6'
                id="ans3"
                checked={this.state.ans1 === '6'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans3">常常</label>
               <input type="radio" value='8'
                id="ans4"
                checked={this.state.ans1 === '8'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans4">總是</label>
              </article>
              <article ref="toNext1">
               <h1>Q2:我不吃甜食或零食。</h1>
               <input type="radio" value='1'
                id="ans5"
                checked={this.state.ans2 === '1'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans5">很少</label>
               <input type="radio" value='3'
                id="ans6"
                checked={this.state.ans2 === '3'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans6">偶爾</label>
               <input type="radio" value='6'
                id="ans7"
                checked={this.state.ans2 === '6'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans7">常常</label>
               <input type="radio" value='8'
                id="ans8"
                checked={this.state.ans2 === '8'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans8">總是</label>
              </article>
               <div>{ nextBtn1 }</div>
              </div>
              <div className="table2" ref="table2">
              <article ref="toQ4">
               <h1>Q3:我吃東西時細嚼慢嚥，每口食物至少嚼二十次才吞下。</h1>
               <input type="radio" value='1'
                id="ans9"
                checked={this.state.ans3 === '1'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans9">很少</label>
               <input type="radio" value='3'
                id="ans10"
                checked={this.state.ans3 === '3'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans10">偶爾</label>
               <input type="radio" value='6'
                id="ans11"
                checked={this.state.ans3 === '6'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans11">常常</label>
               <input type="radio" value='8'
                id="ans12"
                checked={this.state.ans3 === '8'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans12">總是</label>
              </article>
              <article ref="toNext2">
               <h1>Q4:口渴或很熱時，我不喝汽水、可樂、運動飲料、加糖的茶或咖啡飲料而會喝白開水。</h1>
               <input type="radio" value='1'
                id="ans13"
                checked={this.state.ans4 === '1'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans13">很少</label>
               <input type="radio" value='3'
                id="ans14"
                checked={this.state.ans4 === '3'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans14">偶爾</label>
               <input type="radio" value='6'
                id="ans15"
                checked={this.state.ans4 === '6'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans15">常常</label>
               <input type="radio" value='8'
                id="ans16"
                checked={this.state.ans4 === '8'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans16">總是</label>
              </article>
               <div>{ nextBtn2 }</div>
              </div>
              <div className="table3" ref="table3">
              <article ref="toQ6">
               <h1>Q5:我避免吃油炸或含油高的食物（如腰果、花生、瓜子、洋芋片）。</h1>
               <input type="radio" value='1'
                id="ans17"
                checked={this.state.ans5 === '1'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans17">很少</label>
               <input type="radio" value='3'
                id="ans18"
                checked={this.state.ans5 === '3'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans18">偶爾</label>
               <input type="radio" value='6'
                id="ans19"
                checked={this.state.ans5 === '6'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans19">常常</label>
               <input type="radio" value='8'
                id="ans20"
                checked={this.state.ans5 === '8'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans20">總是</label>
              </article>
              <article ref="toNext3">
               <h1>Q6:我每天吃水果。</h1>
               <input type="radio" value='1'
                id="ans21"
                checked={this.state.ans6 === '1'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans21">很少</label>
               <input type="radio" value='3'
                id="ans22"
                checked={this.state.ans6 === '3'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans22">偶爾</label>
               <input type="radio" value='6'
                id="ans23"
                checked={this.state.ans6 === '6'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans23">常常</label>
               <input type="radio" value='8'
                id="ans24"
                checked={this.state.ans6 === '8'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans24">總是</label>
              </article>
               <div>{ nextBtn3 }</div>
              </div>
              <div className="table4" ref="table4">
              <article ref="toQ8">
               <h1>Q7:我每天吃綠色蔬菜。</h1>
               <input type="radio" value='8'
                id="ans25"
                checked={this.state.ans7 === '8'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans25">很少</label>
               <input type="radio" value='6'
                id="ans26"
                checked={this.state.ans7 === '6'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans26">偶爾</label>
               <input type="radio" value='3'
                id="ans27"
                checked={this.state.ans7 === '3'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans27">常常</label>
               <input type="radio" value='1'
                id="ans28"
                checked={this.state.ans7 === '1'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans28">總是</label>
              </article>
              <article ref="toNext4">
               <h1>Q8:我會吃宵夜。</h1>
               <input type="radio" value='8'
                id="ans29"
                checked={this.state.ans8 === '8'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans29">很少</label>
               <input type="radio" value='6'
                id="ans30"
                checked={this.state.ans8 === '6'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans30">偶爾</label>
               <input type="radio" value='3'
                id="ans31"
                checked={this.state.ans8 === '3'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans31">常常</label>
               <input type="radio" value='1'
                id="ans32"
                checked={this.state.ans8 === '1'}
                onChange={this.handleChangeAns8} />
               <label htmlFor="ans32">總是</label>
              </article>
               <div>{ nextBtn4 }</div>
              </div>
              <div className="table5" ref="table5">
              <article ref="toQ10">
               <h1>Q9:我在看電視或看書刊雜誌時吃東西。</h1>
               <input type="radio" value='8'
                id="ans33"
                checked={this.state.ans9 === '8'}
                onChange={this.handleChangeAns9} />
               <label htmlFor="ans33">很少</label>
               <input type="radio" value='6'
                id="ans34"
                checked={this.state.ans9 === '6'}
                onChange={this.handleChangeAns9} />
               <label htmlFor="ans34">偶爾</label>
               <input type="radio" value='3'
                id="ans35"
                checked={this.state.ans9 === '3'}
                onChange={this.handleChangeAns9} />
               <label htmlFor="ans35">常常</label>
               <input type="radio" value='1'
                id="ans36"
                checked={this.state.ans9 === '1'}
                onChange={this.handleChangeAns9} />
               <label htmlFor="ans36">總是</label>
              </article>
              <article ref="toNext5">
               <h1>Q10:我心情不好時，會吃東西來紓解。</h1>
               <input type="radio" value='8'
                id="ans37"
                checked={this.state.ans10 === '8'}
                onChange={this.handleChangeAns10} />
               <label htmlFor="ans37">很少</label>
               <input type="radio" value='6'
                id="ans38"
                checked={this.state.ans10 === '6'}
                onChange={this.handleChangeAns10} />
               <label htmlFor="ans38">偶爾</label>
               <input type="radio" value='3'
                id="ans39"
                checked={this.state.ans10 === '3'}
                onChange={this.handleChangeAns10} />
               <label htmlFor="ans39">常常</label>
               <input type="radio" value='1'
                id="ans40"
                checked={this.state.ans10 === '1'}
                onChange={this.handleChangeAns10} />
               <label htmlFor="ans40">總是</label>
              </article>
               <div>{ nextBtn5 }</div>
              </div>
              <div className="table6" ref="table6">
              <article ref="toQ12">
               <h1>Q11:我用吃來獎勵自己或慶祝。</h1>
               <input type="radio" value='8'
                id="ans41"
                checked={this.state.ans11 === '8'}
                onChange={this.handleChangeAns11} />
               <label htmlFor="ans41">很少</label>
               <input type="radio" value='6'
                id="ans42"
                checked={this.state.ans11 === '6'}
                onChange={this.handleChangeAns11} />
               <label htmlFor="ans42">偶爾</label>
               <input type="radio" value='3'
                id="ans43"
                checked={this.state.ans11 === '3'}
                onChange={this.handleChangeAns11} />
               <label htmlFor="ans43">常常</label>
               <input type="radio" value='1'
                id="ans44"
                checked={this.state.ans11 === '1'}
                onChange={this.handleChangeAns11} />
               <label htmlFor="ans44">總是</label>
              </article>
              <article ref="toNext6">
               <h1>Q12:我在很餓時，才去買東西。</h1>
               <input type="radio" value='8'
                id="ans45"
                checked={this.state.ans12 === '8'}
                onChange={this.handleChangeAns12} />
               <label htmlFor="ans45">很少</label>
               <input type="radio" value='6'
                id="ans46"
                checked={this.state.ans12 === '6'}
                onChange={this.handleChangeAns12} />
               <label htmlFor="ans46">偶爾</label>
               <input type="radio" value='3'
                id="ans47"
                checked={this.state.ans12 === '3'}
                onChange={this.handleChangeAns12} />
               <label htmlFor="ans47">常常</label>
               <input type="radio" value='1'
                id="ans48"
                checked={this.state.ans12 === '1'}
                onChange={this.handleChangeAns12} />
               <label htmlFor="ans48">總是</label>
              </article>
               <div>{ nextBtn6 }</div>
              </div>
             </form>
            </section>
            </div>
          </div>
         </div>
        </div>
      </div>
    )
  }
}

export default Table9;

const Jeyu = {
  Banner: {
    background: 'url('+BG+') center center/ 120%',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  Slogan: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '5px solid #325aaa',
    textAlign: 'center',
    padding: '20px 40px',
    flexDirection: 'column'
  },
  tableBox: {
    background: '#e665a5'
  }
}



// WEBPACK FOOTER //
// ./src/Tables/table9.js